import request from "@/api/request";
import type {IDefaultList, IDefaultResponse, IPaginationRes} from "@/interfaces/general";
import type {
    ICreateInvitationReq,
    IInvitation,
    IUserDetail,
    IUserIndexReq,
    IUserUpdateReq,
    IUserWithRole
} from "@/interfaces/user";

export async function indexUser(params: IUserIndexReq) {
    const {data} = await request<IPaginationRes<IUserWithRole>>({
        url: "/user",
        method: "get",
        params,
    });
    return data
}

export async function listUser() {
    const {data} = await request<IDefaultResponse<IDefaultList[]>>({
        url: "/user/list",
        method: "get",
    });
    return data
}

export async function showUser(id: number) {
    const {data} = await request<IDefaultResponse<IUserDetail>>({
        url: "/user/" + id,
        method: "get",
    });
    return data
}

export async function updateUser(id: number, formData: IUserUpdateReq) {
    const {data} = await request<IDefaultResponse>({
        url: "/user/" + id,
        method: "put",
        data: formData,
    });
    return data
}

export async function deleteUser(id: number) {
    const {data} = await request<IDefaultResponse>({
        url: "/user/" + id,
        method: "delete",
    });
    return data
}

export async function createInvitation(formData: ICreateInvitationReq) {
    const {data} = await request<IDefaultResponse<IInvitation>>({
        url: "/invitation",
        method: "post",
        data: formData,
    });
    return data
}

export async function indexInvitation() {
    const {data} = await request<IDefaultResponse<IInvitation[]>>({
        url: "/invitation",
        method: "get",
    });
    return data
}

export async function showInvitation(id: number) {
    const {data} = await request<IDefaultResponse<IInvitation>>({
        url: "/invitation/" + id,
        method: "get",
    });
    return data
}

export async function resendInvitation(id: number) {
    const {data} = await request<IDefaultResponse>({
        url: "/invitation/" + id + "/resend",
        method: "post",
    });
    return data
}

export async function deleteInvitation(id: number) {
    const {data} = await request<IDefaultResponse>({
        url: "/invitation/" + id,
        method: "delete",
    });
    return data
}

export async function activateUser(id: number) {
    const {data} = await request<IDefaultResponse>({
        url: "/user/" + id + "/activate",
        method: "post",
    });
    return data
}

export async function deactivateUser(id: number) {
    const {data} = await request<IDefaultResponse>({
        url: "/user/" + id + "/deactivate",
        method: "post",
    });
    return data
}